import { copyToClipboard } from "@aries/webview"
import { Toast } from "vant"
import { isApp } from "@/utils/shared.js"

// 内部域名白名单
const INTERNAL_DOMAINS = ["yuanfudao.biz", "yuanfudao.com"]

/**
 * 外部链接处理 Mixin
 * 用于拦截页面中的外部链接点击，复制到剪贴板
 * 版本控制：仅在端内且版本>=5.40.0时生效
 */
export const externalLinkHandlerMixin = {
  methods: {
    /**
     * 处理链接点击事件
     * @param {Event} event - 点击事件
     */
    handleLinkClick(event) {
      // 向上查找最近的 a 标签
      const linkElement = this.findClosestLink(event.target)

      // 未找到链接元素，直接返回
      if (!linkElement || !linkElement.href) {
        console.log("未找到链接元素")
        return
      }

      // 不是外部链接，或者不是端内环境，或者版本不支持，直接返回
      if (!this.isExternalLink(linkElement.href) || !isApp) {
        console.log(
          "非外部链接，或者非端内环境，或者版本不支持，直接返回",
          this.isExternalLink(linkElement.href),
          isApp
        )
        return
      }

      try {
        event.preventDefault() // 阻止默认的链接跳转行为
        const url = linkElement.href
        console.log("复制到剪贴板:", url)
        copyToClipboard(url)
        Toast("链接已复制到剪贴板")
      } catch (error) {
        console.error("复制到剪贴板失败:", error)
        Toast("复制到剪贴板失败")
      }
    },

    /**
     * 向上查找最近的 a 标签
     * @param {Element} element - 起始元素
     * @returns {Element|null} 找到的 a 标签或 null
     */
    findClosestLink(element) {
      let current = element

      // 向上遍历DOM树，直到找到 a 标签或到达根节点
      while (current && current.tagName !== "BODY") {
        if (current.tagName === "A") {
          return current
        }
        current = current.parentElement
      }

      return null
    },

    /**
     * 判断是否为外部链接
     * 外部链接定义：不是 *.yuanfudao.biz 或 *.yuanfudao.com 域名的链接
     * @param {string} url - 要检查的链接
     * @returns {boolean} 是否为外部链接
     */
    isExternalLink(url) {
      try {
        const link = new URL(url)
        const hostname = link.hostname.toLowerCase()

        // 检查是否为猿辅导内部域名
        const isYuanfudaoInternal = INTERNAL_DOMAINS.some(
          (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
        )

        // 如果是猿辅导内部域名，则不是外部链接
        return !isYuanfudaoInternal
      } catch (error) {
        // 如果URL解析失败，保守处理，认为是外部链接
        console.warn("URL解析失败，将作为外部链接处理:", url, error)
        return true
      }
    }
  }
}
